import React from 'react'
import './Imprint.css';

function Imprint() {
    return (
        <div className='text-start imprint'>
            <h1>IMPRINT</h1>
            <br />
            <strong>Publisher</strong>
            <p>
                Published on behalf of the Rector of RWTH Aachen University of Technology from the Institute of Sustainability in Civil Engineering.
            </p>
            <p>
                RWTH Aachen University of Technology<br />
                Templergraben 55<br />
                52062 Aachen (street address)<br />
                52056 Aachen (mailing address)<br />
                Germany<br />
                Phone: +49 241 80 1<br />
                Fax: +49 241 80 92312<br />
                Email: <a href="mailto:impressum@rwth-aachen.de">impressum@rwth-aachen.de</a>
            </p><br />

            <p>
                Institute of Sustainability in Civil Engineering<br />
                RWTH Aachen University of Technology<br />
                Mies-van-der-Rohe.Str. 1<br />
                52074 Aachen<br />
                Germany<br />
                Phone: +49 241 80 2276 9<br />
                Email: <a href="mailto:info@inab.rwth-aachen.de">info@inab.rwth-aachen.de</a><br />
                Website: <a href="https://inab.rwth-aachen.de" target="_blank">inab.rwth-aachen.de</a>
            </p><br />

            <p>
                RWTH Aachen University of Technology is a public institution represented by the Rector:<br />
                Univ.-Prof. Dr. rer. nat. Dr. h.c. mult. Ulrich Rüdiger
            </p><br /><br />
            
            <p>
            <strong>Regulatory Authority</strong><br />
                The Ministry of Culture and Science of the Federal State of North Rhine-Westphalia<br />
                Völklinger Straße 49<br />
                40221 Düsseldorf
            </p><br />

            <p>
            <strong>Sales Tax Identification Number</strong><br />

                In accordance with § 27 Sales Tax Law: DE 121689807
            </p><br />

            <p><strong>Disclaimer</strong></p>

            <u>Accountability for Content</u>
            <p>
                The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents’ accuracy, completeness, or topicality. According to statutory provisions, we are responsible for our own content on these web pages. In this context, please note that we are not obliged to monitor merely the transmitted or saved information of third parties or investigate circumstances pointing to illegal activity. Our obligations to remove or block the use of information under generally applicable laws remain unaffected as per §§ 8 to 10 of the Telemedia Act (TMG).
            </p>

            <u>Liability Notice</u>
            <p>
                Despite careful control of the content, we do not assume any liability for the content of external links. Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.
            </p>
            <p>
                If you follow a link from this website to another website, we recommend that you read the privacy policy on that website to find out what it does with your information.
            </p>
            <p>
                Any error, outdated information, or inaccessible page can be reported to the webmaster.
            </p><br />


            <p>
                <strong>Copyright</strong><br />
                Our web pages and their contents are subject to German copyright law. Unless expressly permitted by law (§ 44a et seq. of the copyright law), every form of utilizing, reproducing, or processing works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. Individual reproductions of a work are allowed only for private use and must not serve either directly or indirectly for earnings. Unauthorized utilization of copyrighted works is punishable (§ 106 of the copyright law).
            </p>
            <p>
                Reproduction of all or part of this site on an electronic medium is authorized for private use subject to indicating the source and mentioning "Rights reserved."
            </p>
        </div>
    )
}

export default Imprint